// extracted by mini-css-extract-plugin
export default {"wrapper":"trait-item_wrapper__epzlY","title":"trait-item_title__arro4","trait":"trait-item_trait__xmSXv","percentage":"trait-item_percentage__UA3qS"};